import React from "react";
import { Link } from "react-router-dom";
import AppStoreIcon from "../assets/img/AppStore.png";
import PlayStoreIcon from "../assets/img/GooglePlay.png";
import GetAppImage from "../assets/img/getApp.png";
import { Col } from "reactstrap";

export default function GetApp() {
  return (
    <div style={styles.bgColor}>
      <div style={styles.innerDiv}>
        <div style={styles.mainLayout}>
          <h2 variant="h2New" component="h2" style={styles.title}>
            Get the app now
          </h2>
          <p variant="subtitle2New" component="div" style={styles.subText}>
            Search hundreds of thousands of up to date listings with powerful
            filters to find your perfect car.
          </p>

          <div style={styles.imageContainer}>
            <Link
              href="https://apps.apple.com/pk/app/graana/id1438849353"
              prefetch={false}
            >
              <img
                src={AppStoreIcon}
                alt="logo"
                width={"141px"}
                // height={"42px"}
              />
            </Link>
            <Link
              href="https://play.google.com/store/apps/details?id=com.graanaapp&hl=en&pli=1"
              prefetch={false}
            >
              <img
                src={PlayStoreIcon}
                alt="logo"
                width={"141px"}
                // height={"42px"}
              />
            </Link>
          </div>
        </div>
        <Col xs="12" md="6" style={styles.imageContainer}>
          <img
            src={GetAppImage}
            alt="mobile"
            style={styles.mobileImage}
            className="img-fluid d-none d-md-block"
          />
        </Col>
        {/* <div>
          <img
            src={GetAppImage}
            alt="mobile"
            style={styles.mobileImage}
            // sizes="100vw"
          />
        </div> */}
      </div>
    </div>
  );
}

const styles = {
  mainLayout: {
    display: "flex",
    paddingTop: "90px",
    paddingBottom: "100px",
    width: "450px",
    flexDirection: "column",
    gap: "18px",
    textAlign: "left",
    "@media (max-width: 1030px)": {
      paddingLeft: "30px",
      paddingRight: "30px",
    },
    "@media (max-width: 700px)": {
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      paddingTop: "36px",
      paddingBottom: "36px",
      paddingLeft: "0px",
      paddingRight: "0px",
    },
  },
  bgColor: {
    backgroundColor: "#fff",
  },
  imageContainer: {
    display: "flex",
    gap: "20px",
    marginTop: "30px",
    "@media (max-width: 700px)": { marginTop: 0 },
  },
  mobileImage: {
    width: "650px",
    height: "520px",
    // marginBottom: "-20px",
    // paddingRight: "10px",
    // "@media (max-width: 700px)": {
    //   display: "none",
    // },
  },
  subText: {
    "@media (max-width: 700px)": {
      display: "none",
    },
  },
  innerDiv: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "1020px",
    margin: "0 auto",
    "@media (max-width: 950px)": {
      paddingLeft: "40px",
    },
    "@media (max-width: 950px)": {
      paddingLeft: "0px",
    },
  },
  title: {
    "@media (max-width: 700px)": {
      fontSize: "1.346rem",
    },
  },
};
